import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_BATCH_FORMS_REQUEST = 'GET_BATCH_FORMS_REQUEST';
export const GET_BATCH_FORMS_SUCCESS = 'GET_BATCH_FORMS_SUCCESS';
export const GET_BATCH_FORMS_FAILURE = 'GET_BATCH_FORMS_FAILURE';

function requestGetBatchForms() {
  return {
    type: GET_BATCH_FORMS_REQUEST,
    isGettingBatchForms: true
  };
}

function receiveGetBatchForms(batchItem, batchFileItem, batchForms, batchFormsCount) {
  return {
    type: GET_BATCH_FORMS_SUCCESS,
    isGettingBatchForms: false,
    batchItem,
    batchFileItem,
    batchForms,
    batchFormsCount
  };
}

function rejectGetBatchForms() {
  return {
    type: GET_BATCH_FORMS_FAILURE,
    isGettingBatchForms: false
  };
}

export function getBatchForms(batchId, batchFileId, pageNumber, pageSize, sortBy, sortDirection, filters) {
  return (dispatch) => {
    dispatch(requestGetBatchForms());
    const promise = () => ApiService
      .getBatchForms(batchId, batchFileId, pageNumber, pageSize, sortBy, sortDirection, filters)
      .then((response) => {
        dispatch(receiveGetBatchForms(response.data.batch, response.data.batchFile, response.data.batchForms, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetBatchForms, true));
        }
      });
    return promise();
  };
}
